/* tslint:disable */
/* eslint-disable */
/**
 * documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetManual200Response,
  GetThemeSettings200Response,
} from '../models/index';

export interface ManualPublicApiGetDocumentRequest {
    tenant: string;
    path: string;
    accessKey: string;
    password?: string;
}

export interface ManualPublicApiGetImageRequest {
    tenant: string;
    imageName: string;
    workingDir: string;
    accessKey: string;
    password?: string;
}

export interface ManualPublicApiGetManualRequest {
    tenant: string;
    accessKey: string;
    password?: string;
}

export interface ManualPublicApiGetThemeSettingsRequest {
    tenant: string;
    accessKey: string;
}

/**
 * 
 */
export class ManualPublicApi extends runtime.BaseAPI {

    /**
     */
    async getDocumentRaw(requestParameters: ManualPublicApiGetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getDocument().'
            );
        }

        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling getDocument().'
            );
        }

        if (requestParameters['accessKey'] == null) {
            throw new runtime.RequiredError(
                'accessKey',
                'Required parameter "accessKey" was null or undefined when calling getDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        if (requestParameters['accessKey'] != null) {
            queryParameters['accessKey'] = requestParameters['accessKey'];
        }

        if (requestParameters['password'] != null) {
            queryParameters['password'] = requestParameters['password'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manual/{tenant}/document`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getDocument(tenant: string, path: string, accessKey: string, password?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDocumentRaw({ tenant: tenant, path: path, accessKey: accessKey, password: password }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getImageRaw(requestParameters: ManualPublicApiGetImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getImage().'
            );
        }

        if (requestParameters['imageName'] == null) {
            throw new runtime.RequiredError(
                'imageName',
                'Required parameter "imageName" was null or undefined when calling getImage().'
            );
        }

        if (requestParameters['workingDir'] == null) {
            throw new runtime.RequiredError(
                'workingDir',
                'Required parameter "workingDir" was null or undefined when calling getImage().'
            );
        }

        if (requestParameters['accessKey'] == null) {
            throw new runtime.RequiredError(
                'accessKey',
                'Required parameter "accessKey" was null or undefined when calling getImage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['imageName'] != null) {
            queryParameters['imageName'] = requestParameters['imageName'];
        }

        if (requestParameters['workingDir'] != null) {
            queryParameters['workingDir'] = requestParameters['workingDir'];
        }

        if (requestParameters['accessKey'] != null) {
            queryParameters['accessKey'] = requestParameters['accessKey'];
        }

        if (requestParameters['password'] != null) {
            queryParameters['password'] = requestParameters['password'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manual/{tenant}/image`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getImage(tenant: string, imageName: string, workingDir: string, accessKey: string, password?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getImageRaw({ tenant: tenant, imageName: imageName, workingDir: workingDir, accessKey: accessKey, password: password }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getManualRaw(requestParameters: ManualPublicApiGetManualRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetManual200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getManual().'
            );
        }

        if (requestParameters['accessKey'] == null) {
            throw new runtime.RequiredError(
                'accessKey',
                'Required parameter "accessKey" was null or undefined when calling getManual().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accessKey'] != null) {
            queryParameters['accessKey'] = requestParameters['accessKey'];
        }

        if (requestParameters['password'] != null) {
            queryParameters['password'] = requestParameters['password'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manual/{tenant}`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getManual(tenant: string, accessKey: string, password?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetManual200Response> {
        const response = await this.getManualRaw({ tenant: tenant, accessKey: accessKey, password: password }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getThemeSettingsRaw(requestParameters: ManualPublicApiGetThemeSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetThemeSettings200Response>> {
        if (requestParameters['tenant'] == null) {
            throw new runtime.RequiredError(
                'tenant',
                'Required parameter "tenant" was null or undefined when calling getThemeSettings().'
            );
        }

        if (requestParameters['accessKey'] == null) {
            throw new runtime.RequiredError(
                'accessKey',
                'Required parameter "accessKey" was null or undefined when calling getThemeSettings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accessKey'] != null) {
            queryParameters['accessKey'] = requestParameters['accessKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manual/{tenant}/theme`.replace(`{${"tenant"}}`, encodeURIComponent(String(requestParameters['tenant']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getThemeSettings(tenant: string, accessKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetThemeSettings200Response> {
        const response = await this.getThemeSettingsRaw({ tenant: tenant, accessKey: accessKey }, initOverrides);
        return await response.value();
    }

}
